/** @file newPuppetReady: whether a New puppet draft has its name, template and every scope choice. */
import type { NewPuppetDraft, ReadyDraft } from './newPuppetTypes';

/** True (narrowing the draft) only when the trimmed name is non-empty and no choice is still unset. */
export function newPuppetReady(d: NewPuppetDraft): d is ReadyDraft {
  return d.name.trim() !== '' && d.template !== null && d.directions !== null && d.pitch !== null && d.camera !== null && d.profile !== null;
}
